import { React, useState } from 'react'
import { Link } from 'react-router-dom';
import AdminHeader from './AdminHeader';
import Sidebar from './Sidebar';
import { FileUploader } from "react-drag-drop-files";
import { FiUploadCloud } from "react-icons/fi";


const fileTypes = ["JPG", "PNG"];
function ProjectSave() {
  const [propertyFile, setFile] = useState(null);
  const [layoutFile, setFile1] = useState(null);
  const [img, setImg] = useState(null);
  const [img1, setImg1] = useState(null);
  const handleChange = (propertyFile) => {
    setFile(propertyFile);
    setImg(URL.createObjectURL(propertyFile[0]));
  };
  const handleChange1 = (layoutFile) => {
    setFile1(layoutFile);
    setImg1(URL.createObjectURL(layoutFile[0]));
  };

  const [isOpen, setOpen] = useState(false);
  // const [isClose, setClose] = useState(false);
  const toggleOpen = () => {
    setOpen(!isOpen);
  };

  const stack2 = (
    <div
      className="drop-layout d-flex flex-column align-items-center justify-content-center"
      
    >
      <div className="box box-1 h-100 text-center ">
        <div className='drop-icon'>
        <FiUploadCloud/>
        </div>
        <div className="drop-text">
        <h2>Drop your images here</h2>
        <p>Upload at least 5 images in jpg or png</p>
    </div>
    <div className="drop-btn ">
        <Link to="">select file</Link>
    </div>
      </div>
     
    </div>
  );

  return (
    <>
      <div className="dashboard">
        <div className={isOpen ? 'd-flex toggled' : 'd-flex'} id="wrapper">
          <Sidebar />
          <div className="page-content">
            <nav className="navbar navbar-expand-lg navbar-light bg-transparent">
              <div className="d-flex align-items-center py-3 ps-3  d-lg-none">
                
                <Link onClick={toggleOpen} role="button"><i className="fas fa-align-left primary-text fs-4 me-3" id="menu-toggle"></i></Link>

              </div>
              <AdminHeader />
            </nav>
            {/* <!-- Areas --> */}
            <div className="dashboard-page p-4">
              {/* contact form starts*/}
              <div className="contact dashboard-form">
                <div className="container">


                  <div className="contact-area">
                    <form action="">
                      <div className="row">

                        <div className="col-lg-12 mb-5 mb-lg-0">

                          <div className="contact-form">

                            <div className="mb-4">
                              <label>Property Description</label>
                              
                                            <textarea name="message" placeholder='Property Description' rows="6"></textarea>
                                        
                            </div>
                            <div className="mb-4">
                              <label>Buy Plot</label>
                              <select className="form-select" aria-label="Default select example">
                                <option selected>Buy Plot</option>
                                <option value="1">Open</option>
                                <option value="2">Sold</option>
                                <option value="3">Reserved</option>
                              </select>
                            </div>
                            <div className="mb-4">
                              
                              <label>Upload Property Images</label>
                              <FileUploader  children={stack2} multiple="true" label="Upload at least 5 images in jpg or png"  handleChange={handleChange} name="propertyFile" types={fileTypes} />
                              <div className='text-center'>
                              <img className='upload-i' src={img} />
                              <p className='file-select'>{propertyFile ? `File name: ${propertyFile[2].name}` : ""}</p>
                              </div>
                            </div>
                            <div className="mb-4">
                              <label>Upload Property Layouts</label>
                              <FileUploader  children={stack2} multiple="true" label="Upload at least 5 images in jpg or png"  handleChange={handleChange1} name="layoutFile" types={fileTypes} />
                              <div className='text-center'>
                              <img className='upload-i' src={img1} />
                              
                              <p className='file-select'>{layoutFile ? `File name: ${layoutFile[0].name}` : ""}</p>
                              </div>
                            </div>
                        

                            

                          </div>
                        </div>


                      </div>
                      <div className="next-button text-end">
                        <Link className='back-btn' to="/dashboard">Back</Link><Link to="/project-save"><button>Save</button></Link>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* contact form ends */}
            </div>
          </div>
        </div>
      </div>


    </>
  )
}

export default ProjectSave